import { createAsyncThunk } from '@reduxjs/toolkit';
import { thunkAxiosRequest } from 'shared/api';
import { Place } from './types';

export const getPlaces = createAsyncThunk<Place[]>(
	'getPlaces',
	async (_, { rejectWithValue }) => {
		return await thunkAxiosRequest({
			path: `/api/v1/places`,
			params: { is_active: true },
			rejectWithValue,
		});
	},
);
